import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'sky-empty-basket',
  templateUrl: './empty-basket.component.html',
  styleUrls: ['./empty-basket.component.scss'],
})
export class EmptyBasketComponent {
  @Input() url = '/quote';

  constructor(private router: Router) {}

  handleViewBasket() {
    this.router.navigate([this.url]);
  }
}
